// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".insights-table--loading{position:absolute;top:50%;left:50%;transform:translateX(-50%) translateY(-50%) scale(1) !important}", ""]);
// Exports
module.exports = exports;
